import { FC } from 'react';
import { StyledCell } from './ViewTableStyles';
import { ViewTableColumn } from './types';
import { ViewTableValueColor } from './constants';

const ViewTableHeader: FC<{
  column: ViewTableColumn;
  index: number;
  colSpan?: number;
  color?: string;
}> = ({ column, index, colSpan = 1, color = ViewTableValueColor.PRIMARY }) => (
  <StyledCell
    colSpan={colSpan}
    sx={{
      backgroundColor: '#2F736E1F',
      fontWeight: column.bold ? 700 : 600,
      minWidth: index === 0 ? 120 : 100,
      color: color ? color : '#1B1C17',
    }}
  >
    {column.label}
  </StyledCell>
);

export default ViewTableHeader;
